// Vendor imports
const _ = require('lodash')
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { FeedItemRecord } = require('client-v2/common/containers/feed/records')
// Container imports
const ArticleProfileRelatedItem = require('./related-item')

const bem = BemEntity('ArticleProfileRelated')

const callbackKeys = [
  'onAddClick',
  'onCollectionsClick',
  'onContentClick',
  'onDomainClick',
  'onMoreActionsClick',
  'onShareClick'
]

class ArticleProfileRelated extends React.PureComponent {
  renderHeading() {
    return (
      tag('div', {
        className: bem.element('heading')
      },
        'People also read'
      )
    )
  }

  renderList() {
    const { items } = this.props
    const callbacks = _.pick(this.props, callbackKeys)
    return (
      tag('ul', {
        className: bem.element('list')
      },
        items.map(item => {
          return tag(ArticleProfileRelatedItem, {
            key: `related-item:${item.id}`,
            className: bem.element('list-item'),
            article: item.article,
            pageContext: item.pageContext,
            ...callbacks
          })
        })
      )
    )
  }

  render() {
    const { items } = this.props
    if (!items || !items.length) {
      return null
    }
    return (
      tag('section', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        this.renderHeading(),
        this.renderList()
      )
    )
  }
}

ArticleProfileRelated.propTypes = {
  // Values
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape(FeedItemRecord.propTypes)
  )
}

// Callback propTypes
callbackKeys.forEach(key => {
  ArticleProfileRelated.propTypes[key] = PropTypes.func.isRequired
})

module.exports = Object.assign(ArticleProfileRelated, {
  callbackKeys
})
